module.exports = __webpack_public_path__ + "static/quest-8123315eee739195b2184af72a441d46.svg";